import React, { useState, useEffect } from "react";
import { useRouter } from "../util/router";

import AdminContents from "../components/admin/AdminContents";
import NotFoundPage from "../components/general/NotFound";
import { useUser } from "../util/user";
import { ProvideUserProps } from "./../util/userDBContext";
// export const UserContext = React.createContext() // broadcast to RemarkForm

function AdminPage() {
	const [hasAccess, setHasAccess] = useState(false);
	const router = useRouter();
	const userObj = useUser();

	useEffect(() => {
		// User is authenticated
		if (userObj != null) {
			// User has access to this page
			if (
				userObj.roles != null &&
				(userObj.roles.includes("administration:_view") ||
					userObj.roles.includes("administration:InvoiceTable:_clientViewInv"))
			)
				setHasAccess(true);
		} else router.push("/solar/logout");
	}, [userObj]);

  return hasAccess ? <ProvideUserProps><AdminContents /></ProvideUserProps> : <NotFoundPage />;
}

export default AdminPage;
